module.exports = __webpack_public_path__ + "img/关系语义.2649afeb.svg";